module.exports = __webpack_public_path__ + "img/笔记本.de20ae26.png";